import { request } from 'apis/request';
import urls from 'apis/configure/urls';

const { apiUrlV1 } = urls;

class LocalOrderService {
  static fetch(originParams) {
    const params = {
      ...originParams,
    };
    return request.get(`${apiUrlV1}/local_order/`, { params });
  }
}

export default LocalOrderService;
